import React from "react";

import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function InfoResource({ resource }: Props) {
  return (
    <div className={styles.dataUser}>
      <div className={styles.avatar}>
        <ResourceAvatar resource={resource} />
      </div>
      <div>
        <p className={styles.name}>{resource.name}</p>
        {resource.userInfo && resource.userInfo.email && (
          <p className={styles.email}>{resource.userInfo.email}</p>
        )}
      </div>
    </div>
  );
}

export { InfoResource };
